import React from 'react';
import { Link } from 'react-router-dom';
import './DeliveryHero.css';

// Reusing a decorative graphic
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const DeliveryHero = () => {
  return (
    <section className="delivery-hero-section">
      <div className="delivery-hero-content">
        <h1>Access intelligence, your way</h1>
        <p>
          CRISHI delivers insights across platforms to match how you work. Get timely updates, structured data, and critical information through the channels you rely on.
        </p>
        <div className="delivery-hero-buttons">
          <Link to="/services">
            <button className="cta-button primary">Explore our services</button>
          </Link>
          <Link to="/signup">
            <button className="cta-button secondary-outline">Book a demo</button>
          </Link>
        </div>
      </div>
      <div className="delivery-hero-graphic">
        <img src={graphicImg} alt="Data Delivery Graphic" />
      </div>
    </section>
  );
};

export default DeliveryHero;